import type { Animal } from './animal.interface';

export interface cv_BreedingStatus {
    Abbreviation: string;
    Animal: Animal[];
    BreedingStatus: string;
    C_BreedingStatus_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    SortOrder: number | null;
    Version: number;
}
